<template>
  <div class="m-upload">
    <!-- :http-request="customUpload" -->
    <el-upload
      ref="mUpload"
      list-type="text"
      :class="{ 'hide-upload-btn': hideUploadBtn }"
      :limit="limitNum"
      :on-success="uploadSuccess"
      accept=".doc, .docx, .xls, .xlsx,.jpg,.png,.rar,.zip,.7z"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :action="uploadUrl"
    >
      <span class="lookClass">点击上传</span>
      <span
        @click.stop="download()"
        v-if="!flgsed"
        style="color: #188ffe; font-size: 14px"
        >下载模板</span
      >
      <br />
      <span v-if="!flgsed" style="margin-left: 10px; color: #999999"
        >仅支持docx,doc,xls,xlsx格式
      </span>

      <!-- <div slot="file" slot-scope="{ file }" style="background:#f9f9f9;display: flex;justify-content: space-between;">
        <span class="el-upload-list__item-thumbnail">{{ file.name }}</span>
        <span>
          <span class="el-upload-list__item-actions" @click="downLoad(file)">
            <i class="el-icon-download" />
          </span>
          <span class="el-upload-list__item-actions" style="margin-left:10px" @click="handleRemove(file)">
            <i class="el-icon-delete" />
          </span>
        </span>
      </div> -->
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss";
import config from "@assets/config.json";
import { string } from "clipboard";
export default {
  components: {},
  model: {
    prop: "logo",
    event: "change",
  },
  props: {
    logo: {
      type: Array,
      default: [],
    },
    limitNum: {
      type: Number,
      default: 1,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    flgsed: {
      type: Boolean,
      default: true,
    },
    size: {
      // 上传图片大小限制  默认 2M
      type: Number,
      default: 50,
    },
    fileList: {
      type: Array,
      default: [],
    },
    importUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadUrl: `${config.api.reqApiAdd}/api/upload/files`,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      client: null,
      downloadlogo: [],
      //   fileList: []
    };
  },
  computed: {
    hideUploadBtn() {
      return this.logo.length && this.logo.length >= this.limitNum;
    },
  },
  watch: {
    logo(val, oldVal) {
      console.log("watch", val);
      console.log("uploadFiles", this.$refs.mUpload.uploadFiles);
      if (!val.length) {
        // logo清空 上传图片files也清空
        this.$refs.mUpload.uploadFiles = [];
      }
      if (!this.$refs.mUpload.uploadFiles.length) {
        // logo有值  上传图片files为空 赋值
        this.init();
      }
    },
  },
  mounted() {
    this.client = new OSS(config.oss);
    this.init();
  },
  created() {},
  methods: {
    init() {
      try {
        if (this.logo && this.logo.length) {
          const arr = [];
          this.logo.forEach((c) => {
            console.log(c);
            const name = c.substring(c.lastIndexOf("/") + 1, c.length);
            arr.push({ name: name, url: c });
          });
          console.log(arr);
          this.fileList = arr;
        }
      } catch (error) {}
    },
    download() {
      console.log(this.importUrl);
      if (this.importUrl) window.location = this.importUrl;
    },
    uploadSuccess(res) {
      console.log("0000000000000000", this.$refs.mUpload.uploadFiles);
      if (res) {
        this.$refs.mUpload.uploadFiles.map((item, index) => {
          const obj = {
            name: item.name,
            kind: "文件",
            url: item.response ? item.response.list[0] : item.url,
          };
          const newArr = [...this.logo, obj];
          this.downloadlogo = [...this.logo, obj];
          //   this.$emit('change', newArr)
          this.$emit("save", newArr);
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limitNum} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    /**
     * 返回随机视频名 /expostar/videos|image/年月/时间戳+5位随机数.filename
     * 1.str 文件名
     * 2.type videos|image  文件名前缀 区别存放视频或者图片目录
     */
    fileName(str, type) {
      const year = new Date().getFullYear();
      var month = new Date().getMonth();
      const time = new Date().getTime();
      if (month < 9) {
        month = "0" + (month + 1);
      } else {
        month = month + 1;
      }
      const prefix = `/${config.oss.bucket}/${type}`; // 文件前缀
      // 返回随机数 n是取值几位数
      let res = "";
      for (
        ;
        res.length < 5;
        res += Math.random().toString(36).substr(2).toUpperCase()
      ) {}
      const random = res.substr(0, 5);
      const name = `${prefix}/${year}${month}/${time}${random}.${str}`;
      return name.toLocaleLowerCase();
    },
    beforeUpload(file) {
      console.log(file.type, file, "file123");
      const isF =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        file.type === "application/msword" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/pdf" ||
        file.type === "" ||
        file.type === "application/x-zip-compressed" ||
        file.type === "image/jpeg";

      const isLtM = file.size / 1024 / 1024 < this.size;
      if (!isF) {
        this.$message.error("仅支持word、excel、图片、pdf和压缩包文件的上传");
      }
      if (!isLtM) {
        this.$message.error(`上传文件大小不能超过 ${this.size}MB!`);
      }
      return isLtM && isF;
    },
    customUpload(options) {
      try {
        const file = options.file;
        const str = file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        const storeAs = this.fileName(str, "file");
        console.log("file", file);
        console.log("options", options);
        console.log("str", str);
        console.log("storeAs", storeAs);
        console.log("config", config);
        // 上传文件,这里是上传到OSS的 uploads文件夹下
        this.client.put(storeAs, file).then((res) => {
          console.log("res", res);
          if (res.res.statusCode === 200) {
            res.imgUrl = config.staticUrl + "/" + res.name;
            options.onSuccess(res);
          } else {
            options.onError("上传失败");
          }
        });
      } catch (e) {
        options.onError("上传失败");
      }
    },
    downLoad(file) {
      console.log(file);
      if (file.response) {
        window.location = file.response.url;
      }
      if (file.url) {
        window.location = file.url;
      }
    },
    handleRemove(file) {
      // 实现缩略图模板时删除文件
      const fileList = this.$refs.mUpload.uploadFiles;
      const index = fileList.findIndex((fileItem) => {
        return fileItem.uid === file.uid;
      });
      fileList.splice(index, 1);
      const arr = [];
      fileList.forEach((c) => {
        arr.push(c);
      });
      this.$emit("change", arr);
      console.log("fileList", arr);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.m-upload {
  .el-upload-list__item {
    width: 100px;
    height: 100px;
    position: relative;
  }
  .el-upload-list {
    display: none !important;
  }
  .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 108px;
  }
  .el-upload-list__item-thumbnail {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    max-width: 100%;
    max-height: 100%;
    width: inherit;
    height: inherit;
  }
  .m-uploader.hide-upload-btn {
    .el-upload--picture-card {
      display: none;
    }
  }
}
</style>
